import React from 'react';

const UserInfo = ({ user, onUpdate }) => {
  // Component implementation
};

export default UserInfo;
